<div role="status" class="w-full flex flex-col gap-2 animate-pulse">
    <!-- Loop through a fixed number of skeleton items -->
    <ng-container *ngFor="let _ of [1, 2, 3, 4, 5]">
      <div class="w-full flex flex-row items-stretch gap-2">
        <div class="w-full flex flex-row items-stretch gap-2">
          <div class="flex-1 px-5 py-2.5 flex flex-row gap-2 items-center justify-between rounded-md bg-white border border-nside-gray-100">
            <div>
              <div class="h-1 bg-gray-300 rounded-full w-24 mb-2.5"></div>
              <div class="w-32 h-1 bg-gray-200 rounded-full"></div>
            </div>
          </div>
          <div class="w-10 flex flex-row items-center justify-center rounded-md border border-nside-gray-100">
            <div class="h-1 bg-gray-300 rounded-full w-6"></div>
          </div>
        </div>
      </div>
    </ng-container>
    <span class="sr-only">Loading...</span>
  </div>
  